import ArticleDetail from './ArticleDetail'
import Aside from './Aside'
import AsideOpener from './AsideOpener'
import Autocomplete from './Autocomplete'
import AutocompleteOld from './AutocompleteOld'
import Body from './Body'
import CalendarFormRegistration from './CalendarFormRegistration'
import CalendarFormRegistrationDateSetter from './CalendarFormRegistrationDateSetter'
import CharCount from './CharCount'
import CheckboxGroup from './CheckboxGroup'
import Choices from './Choices'
import ClassToggle from './ClassToggle'
import CopyToClipboard from './CopyToClipboard'
import DateMask from './DateMask'
import Datepicker from './Datepicker'
import Discussion from './Discussion'
import FeedbackForm from './FeedbackForm'
import FeedbackOpener from './FeedbackOpener'
import FilterGroup from './FilterGroup'
import FilterLayer from './FilterLayer'
import FilterLayerOpener from './FilterLayerOpener'
import FlashMessages from './FlashMessages'
import FocusPoint from './FocusPoint'
import FormLogin from './FormLogin'
import FormPoll from './FormPoll'
import FormSearch from './FormSearch'
import FormSearchOpener from './FormSearchOpener'
import FormTrainingRating from './FormTrainingRating'
import Gallery from './Gallery'
import Graphs from './Graphs'
import NumberInput from './NumberInput'
import Layer from './Layer'
import LayerOpener from './LayerOpener'
import LunchMap from './LunchMap'
import MarketFormAd from './MarketFormAd'
import MarketFormFileItem from './MarketFormFileItem'
import Modal from './Modal'
import ModalOpener from './ModalOpener'
import Nav from './Nav'
import NavOpener from './NavOpener'
import NotificationOpener from './NotificationOpener'
import PaginatorAutoload from './PaginatorAutoload'
import Plan from './Plan'
import PlanOpener from './PlanOpener'
import PressFormFilter from './PressFormFilter'
import Print from './Print'
import Tabs from './Tabs'


const Components = {
    ArticleDetail,
    Aside,
    AsideOpener,
    Autocomplete,
    AutocompleteOld,
    Body,
    CalendarFormRegistration,
    CalendarFormRegistrationDateSetter,
    CharCount,
    CheckboxGroup,
    Choices,
    ClassToggle,
    CopyToClipboard,
    DateMask,
    Datepicker,
    Discussion,
    FeedbackForm,
    FeedbackOpener,
    FilterGroup,
    FilterLayer,
    FilterLayerOpener,
    FlashMessages,
    FocusPoint,
    FormLogin,
    FormPoll,
    FormSearch,
    FormSearchOpener,
    FormTrainingRating,
    Gallery,
    Graphs,
    NumberInput,
    Layer,
    LayerOpener,
    LunchMap,
    MarketFormAd,
    MarketFormFileItem,
    Modal,
    ModalOpener,
    Nav,
    NavOpener,
    NotificationOpener,
    PaginatorAutoload,
    Plan,
    PlanOpener,
    PressFormFilter,
    Print,
    Tabs,
}

export default Components